import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DateTimeLabelViewModelType from '@/ViewModels/Controls/DateTimeLabelViewModel';
import LabelType from '@/Controls/Label';

export default class DateTimeLabel extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;

    public constructor(private viewModel: DateTimeLabelViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<span>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'datetimelabel',

            locator: this.viewModel.locator,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            }),

            text: this.viewModel.date
        });
    }
}

ComponentManager.setControl('DateTimeLabel', DateTimeLabel, 'RADPresentation.HTMLClient.DefaultViewExtensions');